module.exports = __webpack_public_path__ + "img/14.1a3c8385.jpg";